/* Will actually replace any double triple etc slashes with one '/' */
const removeDoubleSlashes = (path: Readonly<string>) => path.replaceAll(/\/{2,}/gu, '/');

const ensureStartingSlash = (path: Readonly<string>) => (path.startsWith('/') ? path : `/${path}`);

const removeTrailingSlash = (path: Readonly<string>) =>
    path.endsWith('/') ? path.slice(0, -1) : path;

const _NoOp = (path: Readonly<string>) => path;

export type UrlSanitizer = (path: Readonly<string>) => string;

export interface IUrlOptions {
    requireLeadingSlash?: boolean;
    removeTrailingSlash?: boolean;
    removeDoubleSlashes?: boolean;
    operators?: UrlSanitizer[];
}

export const UrlDefaults: Required<IUrlOptions> = {
    requireLeadingSlash: true,
    removeTrailingSlash: false,
    removeDoubleSlashes: true,
    operators: [],
};

function sanitizePath(path: string, optionsIn?: IUrlOptions): string {
    const options: Required<IUrlOptions> = {
        ...UrlDefaults,
        ...optionsIn,
    };

    const operators: UrlSanitizer[] = [
        ...options.operators,
        options.requireLeadingSlash ? ensureStartingSlash : _NoOp,
        options.removeTrailingSlash ? removeTrailingSlash : _NoOp,
        options.removeDoubleSlashes ? removeDoubleSlashes : _NoOp,
    ];

    const result = operators.reduce((currentValue, op) => op(currentValue), path);
    return result;
}

export default Object.freeze({
    operators: {
        removeDoubleSlashes,
        ensureStartingSlash,
        removeTrailingSlash,
    },
    allOperators: [removeDoubleSlashes, ensureStartingSlash, removeTrailingSlash],
    sanitizePath,
});
